import {ADD_SIDE_LID} from "../constants/constants";

export const  addLid =  (data) => {
    return {
        type : ADD_SIDE_LID,
        payload : {...data}
    };
};


// WEBPACK FOOTER //
// ./src/actions/addLid.js